import { ILocation } from '../../models';

export const getLocationSearchOptionLabel = (option: ILocation) => {
	if (!option.country) return '';

	let label = option.country;
	if (option.city) {
		label += `, ${option.city}`;
	}
	if (option.office) {
		label += `, ${option.office}`;
	}
	return label;
};
